<template>
  <div class="col-12 w-100" style="padding-top: 20px">
    <h3 class="text-center fc-2">
      Kampanyalara Katılmak İçin
      <br />
      <span style="font-size: 145%" class="fc-1">Uygulamayı İndirin</span>
    </h3>
    <div style="display: flex; align-items: center; justify-content: center; margin-top: 10px">
      <a
        target="_blank"
        href="https://play.google.com/store/apps/details?id=com.creasoup.aeskfancard"
      >
        <img
          style="height: 45px"
          src="https://play.google.com/intl/en_us/badges/images/badge_new.png"
        />
      </a>
      <a
        target="_blank"
        href="https://apps.apple.com/tr/app/anadolu-efes-spor-kul%C3%BCb%C3%BC/id1050153694?l=tr#?platform=iphone"
      >
        <img
          style="height: 45px"
          src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-example-preferred.png"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadApp"
};
</script>


// WEBPACK FOOTER //
// src/components/DownloadApp.vue